module.exports = __webpack_public_path__ + "img/14.17e36dd.png";